/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Credential_UnavailableInputs */

const es_co2_error_credential_unavailable = /** @type {(inputs: Error_Credential_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay una llave disponible para copiar.`)
};

/**

* @param {Error_Credential_UnavailableInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_credential_unavailable = /** @type {((inputs?: Error_Credential_UnavailableInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Credential_UnavailableInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_credential_unavailable(inputs)
});